import Vue from 'vue'
import '@/utils/vue-storage'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './i18n'
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
import infiniteScroll from 'vue-infinite-scroll'
import Global from './global'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import '@/styles/index.less'
import '@/icons/index'

import './router/guard'

import {
  Drawer,
  Form,
  FormModel,
  Button,
  Select,
  Input,
  message,
  Menu,
  Modal,
  Divider,
  Layout,
  Tree,
  Icon,
  Row, Col,
  notification,
  Checkbox,
  Tooltip,
  Radio,
  DatePicker
} from 'ant-design-vue'
import { CACHE_KEY, LANGUAGE, PAGE_NAME, ONE_DAY_MILLSECS } from './utils/constant'
import observer from './utils/observer'
import { userChecker } from './utils/user-checker'
import { hileiaHttp, platformHttp } from './utils/http'
import { OutSideDirective } from './directives/outside'
import qs from 'qs'

[
  Drawer,
  Form,
  FormModel,
  FormModel.Item,
  Button,
  Select,
  Form.Item,
  Input,
  Menu,
  Menu.Item,
  Modal,
  Divider,
  Layout,
  Tree,
  Icon,
  Row, Col,
  Checkbox,
  Tooltip,
  Radio,
  DatePicker
].forEach(plugin => Vue.use(plugin))

Vue.directive('infiniteScroll', infiniteScroll)

Vue.use(OutSideDirective)

Vue.component('SvgIcon', SvgIcon)

Vue.config.productionTip = false
message.config({
  top: '80px'
})
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$confirm = Modal.confirm

axios.defaults.withCredentials = true

function isNotLoginPage () { // 这句条件有局限性，目前仅限定了login SigninToCode 页面的请求不限定
  return router.currentRoute.name !== PAGE_NAME.Login && router.currentRoute.name !== PAGE_NAME.SigninToCode
}

function isInRoom () {
  return router.currentRoute.name === PAGE_NAME.Talking
}

function axiosRequestInterceptor (config) {
  if (userChecker.checkCookieUser() && isNotLoginPage()) {
    observer.$emit('logout')
    throw new Error(i18n.tc('main.SwitchedOrNotLogin'))
  }

  config.headers['X-CTName'] = process.env.VUE_APP_TOKEN_CTNAME
  config.headers['Accept-Language'] = i18n.locale === LANGUAGE.CHINESE ? LANGUAGE.CHINESE_BACKEND : LANGUAGE.ENGLISH_BACKEND

  config.headers['HiLeia-Version'] = Global.VERSION
  config.headers['HiLeia-TraceId'] = new Date().getTime()
  config.headers['HiLeia-Os'] = 'WEB'

  if (!config.headers.HiARGlassesToken) {
    config.headers.HiARGlassesToken = store.state.userInfo.token || ''
  }

  return config
}

axios.interceptors.request.use(axiosRequestInterceptor)
axios.interceptors.response.use(res => {
  if (+res.data.code === 1902) {
    store.commit('clearCurrentSession')
    Vue.nextTick(_ => {
      router.replace({ name: PAGE_NAME.Login, query: { redirect: '/' } })
    })
  }
  return res
})
platformHttp.interceptors.request.use(axiosRequestInterceptor)
hileiaHttp.interceptors.request.use(axiosRequestInterceptor)

// 检测是否从飞象跳转过来
const checkIsFromFeiiplatOauth = () => {
  const fullPath = location.href
  const qsMatch = fullPath.match(/\?.*/)
  const qsTotal = qsMatch && qsMatch[0] && qsMatch[0].replace(/^\?/, '')
  const qsObj = qsTotal && qs.parse(qsTotal)
  // 如果queryString中存在use这个键，说明是从飞象跳转过来
  return qsObj && 'use' in qsObj
}

// 如果缓存中有登录信息，则进行恢复登录的流程；但如果是从飞象过来的一律不恢复，走重新登录
if (!Vue.ss.get(CACHE_KEY.NAV_TAG_LOGOUT) && !checkIsFromFeiiplatOauth()) {
  try {
    const sessionUserInfo = Vue.ls.get(CACHE_KEY.HILEIA_USER_INFO)
    if (sessionUserInfo !== null) {
      Vue.ls.set(CACHE_KEY.HILEIA_USER_INFO, sessionUserInfo, ONE_DAY_MILLSECS)
      userChecker.setStateUserId(sessionUserInfo.id)
      if (userChecker.checkCookieUser()) {
        observer.$emit('logout')
      } else {
        store.dispatch('recoverUserSession', sessionUserInfo)
      }
    }
  } catch (err) {
  }
}

store.subscribe((mutation, _state) => {
  if (mutation.type === 'clearToken') {
    if (isNotLoginPage()) {
      router.replace({
        name: PAGE_NAME.Login,
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }
  }
})

observer.$on('logout', (respErr) => {
  store.dispatch('mqttLogout')
  store.dispatch('logoutReset')
})

// 页面可见时判断mqtt是否离线，如果离线就发起登录
Global.addPageVisibilityChangeEvent(() => {
  if (store.state.isMqttOffline) {
    console.log('mqtt离线，准备重新登录')
    store.dispatch('mqttLogin')
  }
})

// 断网30s退出房间
const timer = {
  MAX: 30,
  value: 0,
  interval: 0,
  clearInterval () {
    timer.value = 0
    clearInterval(timer.interval)
  },
  setInterval () {
    timer.interval = setInterval(_ => {
      if (timer.value >= timer.MAX) {
        message.error({
          content: i18n.tc('main.RejoinCollaborationOfDisconnected'),
          key: 'offline-state-DxE4',
          onClose () {
            if (isInRoom()) {
              store.commit('clearCurrentSession')
              const time = setTimeout(async _ => {
                clearTimeout(time)
                await store.dispatch('leaveRtcRoom')
                await store.commit('clearWhiteBoardLinesData')
                await store.commit('removeWhiteBoardImage')
                Vue.ss.remove(CACHE_KEY.MEMBER_AVATAR)
                Vue.ss.remove(CACHE_KEY.TALKING_DURATION)
                // router.replace({ name: PAGE_NAME.Home })
              }, 0)
            }
          }
        })
        timer.clearInterval()
      }
      timer.value++
    }, 1000)
  }
}

// 监听网络状态，给出相应的提示语
let isOffline
window.addEventListener('offline', () => {
  timer.setInterval()
  isOffline = true
  message.error({
    content: i18n.tc('main.InternetUnavailable'),
    duration: 0,
    key: 'network-tip'
  })
})
window.addEventListener('online', () => {
  timer.clearInterval()
  if (isOffline) {
    isOffline = false
    Modal.warning({
      keyboard: false,
      okText: i18n.tc('main.Refresh'),
      title: i18n.tc('main.NetworkRecovery'),
      content: i18n.tc('main.RefreshPageAvoidProblems'),
      onOk: _ => {
        window.location.reload()
      }
    })
  }
})

window.addEventListener('storage', (e) => {
  const key = e.key
  if (key === CACHE_KEY.HILEIA_USER_INFO) {
    store.dispatch('ignoreCall')
    store.commit('setTokenState')
    store.dispatch('logoutResetOfNotLogout') // token不能删除，所有在添加一个变量在控制
    if (router.currentRoute.name !== PAGE_NAME.Login) {
      router.replace({ name: PAGE_NAME.Login, query: { redirect: router.currentRoute.fullPath } })
    }
  }
}, false)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
